// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oPLN","disabled":"styles_disabled__1p3y9"};